import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';
import { getIncentiveTemplates } from 'redux/actions/settingsOverview';
import { selectIncentiveTemplates } from 'redux/selectors/settingsOverview';
import { StateType } from '../../types';
import { selectCohortData, selectIsLoading } from '../../redux/selectors/cohort';
import { getCohortById, patchCohortById } from '../../redux/actions/cohort';

const mapStateToProps = (state: StateType) => ({
  selectedCohort: selectCohortData(state),
  isLoading: selectIsLoading(state),
  incentiveTemplates: selectIncentiveTemplates(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    getCohortById,
    patchCohortById,
    getIncentiveTemplates,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
